import type { ReferralModel } from '@ctw/shared/api/fhir/models/referral';
import { usePatientReferrals } from '@ctw/shared/hooks/use-patient-referrals';

export interface PatientReferralsOverviewData {
  data: Array<ReferralModel>;
  isLoading: boolean;
  hasNoRecords: boolean;
}

/**
 * Fetches the referrals shown in the patient overview card. Grouping by status
 * is a presentation concern and lives in the card.
 */
export function usePatientReferralsOverviewData(): PatientReferralsOverviewData {
  const referralsQuery = usePatientReferrals();
  const data = referralsQuery.data ?? [];

  return {
    data,
    isLoading: referralsQuery.isLoading,
    hasNoRecords: data.length === 0,
  };
}
